const advancedFiltersText = {
  id: 'ordersKanbanAdvancedFiltersToolbar.filters',
}

const textIds = {
  advancedFiltersText,
}

export default textIds
